import styled from 'styled-components';
import { DatePicker } from 'antd';
import { useState } from 'react';
import { Moment } from 'moment';

import { DiligencePayload, EmployeeGrowthPayload } from 'types';
import { DatePickerIcon } from 'assets/icons';
import { SelectField } from 'components/FormFields';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const StyledWrapperYear = styled.div`
  .ant-picker {
    border-radius: 6px;
    border: 1px solid var(--cl_neutral300);
  }
`;

interface EmployeeGrowthFiltersProps {
  loading?: boolean;
  initialValues?: any;
  onSubmit?: (payload: any) => void;
  location?: any;
}

export default function PayrollInDetailFilters({
  initialValues,
  onSubmit,
  location,
}: EmployeeGrowthFiltersProps) {
  const [monthYear, setMonthYear] = useState<Moment | null>(initialValues?.monthYear || null);
  const { t } = useTranslation(['dashboard']);

  const { control, handleSubmit } = useForm<DiligencePayload>({
    defaultValues: initialValues,
  });

  const handleFiltersSubmit = (value: any) => {
    onSubmit?.({ value, from: 'location' });
  };

  const viewByOptions = location?.map((item) => ({ label: item?.name, value: item?.id }));
  return (
    <StyledWrapperYear style={{ display: 'flex' }}>
      <div style={{ display: 'flex', alignItems: 'center', marginRight: 20 }}>
        <p style={{ padding: 0, margin: 0, marginRight: 10, fontWeight: 600 }}>Location</p>
        <SelectField
          style={{
            width: 130,
          }}
          name="viewByLocation"
          control={control}
          options={viewByOptions || []}
          showSearch
          allowClear={false}
          onChange={handleSubmit(handleFiltersSubmit)}
        />
      </div>
      <div style={{ display: 'flex', alignItems: 'center', marginRight: 20 }}>
        <p style={{ margin: 0, padding: 0, marginRight: 10, fontWeight: 600 }}>Pay Period</p>
        <DatePicker
          style={{ width: 110 }}
          picker="month"
          value={monthYear}
          allowClear={false}
          suffixIcon={<DatePickerIcon />}
          onChange={(value) => {
            setMonthYear(value);
            onSubmit?.({ value, from: 'monthYear' });
          }}
        />
      </div>
    </StyledWrapperYear>
  );
}
